<template>
  <div
    style="background-color: rgba(0, 0, 0, 0.2); z-index: 2040; display: none; position:fixed; top:0px; right:0px; bottom:0px; left:0px;"
    :class="show?'d-block':'d-none'"
  >
    <div style="position:absolute;width:100%;top:50%;" class="text-center">
      <b-spinner style="width: 3rem; height: 3rem; " variant="primary"></b-spinner>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  }
};
</script>

